/* eslint-disable no-restricted-syntax */
export default null;

export function GetFloatNumber(number) {
    if (Number.isNaN(number)) {
        return 0;
    }
    return number?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export function GetNumberWithZero(number) {
    const numberAr = number?.toString().split('');

    if (numberAr && numberAr.length === 1) {
        return `0${number}`;
    }
    return number;
}
export function GetNumberBeforeZero(number) {
    const numberAr = number?.toString().split('');

    if (numberAr.length === 1) {
        return `0${number}`;
    }
    return number;
}

export function GetNumberWithComma(number) {
    return number?.toLocaleString('en-US');
}

export function GetNumberToWords(number) {
    // Check if the input is a valid number
    if (Number.isNaN(number)) {
        return 'Invalid number';
    }
    // Check if the input is zero
    if (number === 0) {
        return 'Zero';
    }
    // Check if the input is a negative number
    if (number < 0) {
        return `Negative ${GetNumberToWords(Math.abs(number))}`;
    }

    const singleDigits = [
        '',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine'
    ];
    const teens = [
        '',
        'eleven',
        'twelve',
        'thirteen',
        'fourteen',
        'fifteen',
        'sixteen',
        'seventeen',
        'eighteen',
        'nineteen'
    ];
    const tens = [
        '',
        'ten',
        'twenty',
        'thirty',
        'forty',
        'fifty',
        'sixty',
        'seventy',
        'eighty',
        'ninety'
    ];

    // Function to convert integer part of a number to words
    function convertIntegerToWords(integerPart) {
        if (integerPart === 0) {
            return '';
        }

        if (integerPart < 10) {
            return singleDigits[integerPart];
        }

        if (integerPart >= 11 && integerPart <= 19) {
            return teens[integerPart - 10];
        }

        if (integerPart < 100) {
            return `${tens[Math.floor(integerPart / 10)]} ${singleDigits[integerPart % 10]}`;
        }

        if (integerPart < 1000) {
            return `${singleDigits[Math.floor(integerPart / 100)]} hundred ${convertIntegerToWords(
                integerPart % 100
            )}`;
        }

        if (integerPart < 1000000) {
            return `${convertIntegerToWords(
                Math.floor(integerPart / 1000)
            )} thousand ${convertIntegerToWords(integerPart % 1000)}`;
        }

        if (integerPart < 1000000000) {
            return `${convertIntegerToWords(
                Math.floor(integerPart / 1000000)
            )} million ${convertIntegerToWords(integerPart % 1000000)}`;
        }

        if (integerPart < 1000000000000) {
            return `${convertIntegerToWords(
                Math.floor(integerPart / 1000000000)
            )} billion ${convertIntegerToWords(integerPart % 1000000000)}`;
        }

        return 'Number out of range';
    }

    // Function to convert decimal part of a number to words
    function convertDecimalToWords(decimalPart) {
        let result = '';
        let decimalString = decimalPart.toFixed(10).substring(2); // Remove the "0." from the string
        decimalString = decimalString.replace(/0+$/, ''); // Remove trailing zeros
        for (const digit of decimalString) {
            result += ` ${singleDigits[Number(digit)]}`;
        }
        return result.trim();
    }

    // Split number into integer and decimal parts
    const integerPart = Math.floor(number);
    const decimalPart = number - integerPart;

    // Convert integer part to words
    let result = convertIntegerToWords(integerPart);

    // If decimal part exists, convert it to words and append
    if (decimalPart !== 0) {
        result += ` & ${convertDecimalToWords(decimalPart)}`;
    }

    return result;
}
